import { BenefitsEnrollmentStateEnum } from "@oysterhr/schema"

const UNDELETABLE_PRICE_ENROLLMENT_STATES = new Set([
  BenefitsEnrollmentStateEnum.Denied,
  BenefitsEnrollmentStateEnum.Enrolled,
  BenefitsEnrollmentStateEnum.Finished,
  BenefitsEnrollmentStateEnum.AwaitingToBeFinished,
  BenefitsEnrollmentStateEnum.OptedOut,
  undefined,
])

export function isDeletingSavedPricesAllowed(enrollmentState?: BenefitsEnrollmentStateEnum) {
  return !UNDELETABLE_PRICE_ENROLLMENT_STATES.has(enrollmentState)
}
